import { useSelector } from "react-redux";

import {
  selectRecentEvent,
  selectRecentEventForReview,
} from "../store/slices/socket/selectors";
import type { RootState } from "../store/store";
import type { IQueueEvent } from "../store/types";

/**
 * Returns the most recent event based on the current active view mode.
 *
 * - Review modes (Coach, Bullpen, Batting Practice) use `selectRecentEventForReview`
 *   to keep events visible after tagging, enabling continuous visualization and analysis.
 * - Tagging modes (Game) use `selectRecentEvent` to auto-advance to the next
 *   untagged event, creating an efficient tagging workflow.
 *
 * @returns The most recent event appropriate for the current mode
 */
export const useRecentEventForCurrentMode = (): IQueueEvent => {
  const activeView = useSelector((state: RootState) => state.view.activeView);

  const isReviewMode =
    activeView === "Coach Mode" ||
    activeView === "Bullpen Mode" ||
    activeView === "Batting Practice Mode";

  return useSelector((state: RootState) =>
    isReviewMode ? selectRecentEventForReview(state) : selectRecentEvent(state),
  );
};
